export function arrayHasContent<T>(array: T[]): boolean {
    return typeof array === 'object' && Array.isArray(array) && array.length > 0
}